import React,{useState} from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const BuildMetricTable = ({ data }) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const columns = Object.keys(data[0]);
    // const numRows = data.length;
    // const numCols = columns.length;

     // Define column header styles
  const columnStyles = {
    backgroundColor: "#152C73", 
    color: "white", 
    fontWeight: "bold", 
    position: "sticky",
    top: 0,
    zIndex: 1,
    textAlign: "center",
    padding: "10px",
    borderBottom: "1px solid #ddd",
  };

  // Define row styles with hover and alternating row colors
  const rowStyles = (index) => ({
    backgroundColor:
      hoveredRow === index
        ? "#D1D5DB" // Hover color
        : index % 2 === 0
        ? "#E3E7ED" // Light gray for even rows
        : "#F1F5F9", // Lighter gray for odd rows
    cursor: "pointer", // Pointer cursor on hover
  });

    const handleDownload = () => {
        alert("Sorry, Download feature is not yet implemented !!! ")
    };

    return (
        <>

<TableContainer
        component={Paper}
        style={{
          maxHeight: '60vh',
          overflow: 'auto',
        //   width: "82vw",
          margin: '0 auto',
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((columnName, index) => (
                <TableCell key={index} style={columnStyles}>
                  {columnName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                style={rowStyles(rowIndex)}
                onMouseEnter={() => setHoveredRow(rowIndex)} // Highlight row on hover
                onMouseLeave={() => setHoveredRow(null)} // Reset highlight on mouse leave
              >
                {columns.map((columnName, columnIndex) => (
                  <TableCell
                    key={columnIndex}
                    style={{
                      textAlign: "center",
                      padding: "8px",
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {row[columnName]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
        </>
    );
};

export default BuildMetricTable;
